import {BoxProps, Flex, Image, Text} from "@chakra-ui/react";
import {useNav} from "../../context";

const MobileHeader = (props: {
  title: string;
  pl?: string;
  onClick?: VoidFunction;
  isBackButton?: boolean;
} & BoxProps) => {
  const sidebarState = useNav();

  return <Flex
      display={{ base: "flex", lg: "none" }}
      alignItems="center"
      gap="8px"
      w="full"
      bgColor={props.bg ?? "white"}
      pl={props.pl}
      _hover={{cursor: props.isBackButton ? "pointer" : "default"}}
      onClick={props.isBackButton ? props.onClick : undefined}
    >
      <Image
        src={props.isBackButton ? "/images/chevron-left.svg" : "/images/menu-01.svg"}
        _hover={{ cursor: "pointer" }}
        onClick={
          props.isBackButton
            ? props.onClick
            : () => {
                if (!sidebarState.isOpen) {
                  sidebarState.onOpen();
                }
              }
        }
      />
      <Text
        fontWeight={500}
        lineHeight="22px"
        color={props.isBackButton ? "dark.500" : "primary.500"}
        fontSize="18px"
      >
        {props.title}
      </Text>
    </Flex>;
};

export default MobileHeader;
